import { useState } from 'react'
import TextField from '@mui/material/TextField'
import FormRow from 'components/FormRow'
import { EmailInputProps } from './types'

export default function EmailInputMui( {
	label,
	value,
	onChange,
	onBlur,
	placeholder = '',
	isInvalid = false,
	error,
	helpText,
}: EmailInputProps ) {
	const [ hasBlurred, setHasBlurred ] = useState( false )

	const handleBlur = () => {
		setHasBlurred( true )
		if ( onBlur ) {
			onBlur( value )
		}
	}

	// Only show validation errors after the user has blurred the field
	const shouldShowError = hasBlurred && isInvalid

	return (
		<FormRow
			label={label}
			isInvalid={shouldShowError}
			error={shouldShowError ? error : undefined}
			helpText={helpText}
			fullWidth
		>
			{/* `error`/`fullWidth` come from FormRow's injection (below), not here —
			    it clones this element with those props already computed. */}
			<TextField
				placeholder={placeholder}
				value={value}
				onChange={( e ) => onChange( e?.target?.value ?? '' )}
				onBlur={handleBlur}
			/>
		</FormRow>
	)
}
